module.exports = __webpack_public_path__ + "img/sweden-respiratory-diseases-female.0e31cd56.png";